
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue');

import counterUp from 'counterup2';
import Typed from 'typed.js';
import 'jquery.easing';

import { 
	Form,
	HasError,
	AlertError,
	AlertErrors, 
	AlertSuccess
  } from 'vform'
window.Form = Form;

import VueProgressBar from 'vue-progressbar'
const options = {
	color: '#28a745',
	failedColor: '#dc3545',
	thickness: '5px',
	transition: {
	  speed: '0.2s',
	  opacity: '0.6s',
	  termination: 300
	},
	autoRevert: true,
	location: 'top',
    inverse: false,
    autoFinish: false
  }
  
  import Multiselect from 'vue-multiselect';
  Vue.component('vue-multiselect', Multiselect)

  Vue.use(VueProgressBar, options)
  
  import swal from 'sweetalert2';
  window.Swal = swal;
  
  const Toast = Swal.mixin({
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 5000
  });
  
  window.toast = Toast;

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

Vue.component('ext-menu', require('./components/External/ExtMenu.vue').default);
Vue.component('ext-intro', require('./components/External/ExtIntro.vue').default);
Vue.component('ext-sobre', require('./components/External/ExtSobre.vue').default);
Vue.component('ext-services', require('./components/External/ExtServices.vue').default);
Vue.component('ext-counter', require('./components/External/ExtCounter.vue').default);
Vue.component('ext-portfolio', require('./components/External/ExtPortfolio.vue').default);
Vue.component('ext-testemunhos', require('./components/External/ExtTestemunhos.vue').default);
Vue.component('ext-blog', require('./components/External/ExtBlog.vue').default);
Vue.component('ext-contact', require('./components/External/ExtContact.vue').default);
Vue.component('ext-ldo', require('./components/External/LDO.vue').default);

Vue.component(HasError.name, HasError)
Vue.component(AlertError.name, AlertError)
Vue.component(AlertErrors.name, AlertErrors)
Vue.component(AlertSuccess.name, AlertSuccess)

import VTooltip from 'v-tooltip';
Vue.use(VTooltip, {
    defaultBoundariesElement: document.body,
});

const app = new Vue({
    el: '#app',
    components: {}
});

let elements = document.getElementsByClassName('counter');
for(let i=0; i<elements.length; i++){
    counterUp( elements[i], {
        duration: 1000,
        delay: 16,
    });
};

/*--/ Star Typed /--*/
if ($('.text-slider').length == 1) {
var typed_strings = $('.text-slider-items').text();
    var typed = new Typed('.text-slider', {
        strings: typed_strings.split(','),
        typeSpeed: 80,
        loop: true,
        backDelay: 1100,
        backSpeed: 30
    });
}

var nav = $('nav');
var navHeight = nav.outerHeight();


// Back to top button
$(window).scroll(function() {
    if ($(this).scrollTop() > 100) {
        $('.back-to-top').fadeIn('slow');
    } else {
        $('.back-to-top').fadeOut('slow');
    }
});

$('.back-to-top').click(function(){
    $('html, body').animate({scrollTop : 0},1500, 'easeInOutExpo');
    return false;
});

/*--/ Star ScrollTop /--*/
$('.scrolltop-mf').on("click", function () {
    $('html, body').animate({
        scrollTop: 0
    }, 1000);
});

/*--/ Star Counter /--*/
let el = document.getElementsByClassName('counter');
for(let i=0; i<el.length; i++){
    counterUp( el[i], {
        duration: 1000,
        delay: 16,
    });
}


/*--/ Star Scrolling nav /--*/
$('a.js-scroll[href*="#"]:not([href="#"])').on("click", function () {
    if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
        if (target.length) {
            $('html, body').animate({
                scrollTop: (target.offset().top)
            }, 1000, "easeInOutExpo");
            return false;
        }
    }
});

// Closes responsive menu when a scroll trigger link is clicked
$('.js-scroll').on("click", function () {
    $('.navbar-collapse').collapse('hide');
});

// Activate scrollspy to add active class to navbar items on scroll
$('body').scrollspy({
    target: '#mainNav',
    offset: navHeight
});
/*--/ End Scrolling nav /--*/

/*--/ Navbar Menu Reduce /--*/
$(window).trigger('scroll');
$(window).on('scroll', function () {
    var pixels = 50; 
    var top = 1200;
    if ($(window).scrollTop() > pixels) {
        $('.navbar-expand-md').removeClass('navbar-trans');
    } else {
        $('.navbar-expand-md').addClass('navbar-trans');
    }
    if ($(window).scrollTop() > top) {
        $('.scrolltop-mf').fadeIn(1000, "easeInOutExpo");
    } else {
        $('.scrolltop-mf').fadeOut(1000, "easeInOutExpo");
    }
});


export default app;